import { render, staticRenderFns } from "./FormUserReport.vue?vue&type=template&id=9a6d6254"
import script from "./FormUserReport.vue?vue&type=script&lang=js"
export * from "./FormUserReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports